import { render, staticRenderFns } from "./TableTabs.vue?vue&type=template&id=0fcb2b94&scoped=true&"
import script from "./TableTabs.vue?vue&type=script&lang=js&"
export * from "./TableTabs.vue?vue&type=script&lang=js&"
import style0 from "./TableTabs.vue?vue&type=style&index=0&id=0fcb2b94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcb2b94",
  null
  
)

export default component.exports